'use strict';

import React                                  from 'react';
import {render, unmountComponentAtNode}       from 'react-dom';
import NavBar                                 from '../components/NavBar/NavBar';
import {run as NavBarRunner}                  from "./NavBarHelper";
import NavBarTablet                           from "../components/NavBar/NavBarTablet";
import PhoneAccess                            from "../components/PhoneAccess";
import PjaxWrapper                            from '../utils/PjaxWrapper';
import Flux                                   from "../flux/Flux";
import Constants                              from "../flux/Constants";
import {setNavIntoNonSticky, toggleStickyNav} from "./Index";
import {getVoicecallLabel}                    from "../utils/TranslationHelper";

/**
 * @param {string} navBarContainerId
 * @param {string} navBarTabletContainerId
 * @param {string} phoneAccessContainerId
 * @param {array} navigationLinks
 * @param {boolean} showPhoneAccess
 * @param {boolean} scrollToView
 */
function run(navBarContainerId, navBarTabletContainerId, phoneAccessContainerId, navigationLinks, showPhoneAccess, scrollToView) {
    const voiceCallLabel = getVoicecallLabel(Flux.Guest.isLoggedIn(), Flux.Guest.isTestActive(Constants.TestId.VOICECALL_NEWCOMERS));

    // clean up NavBar remainings
    let elem;
    while ((elem = document.getElementById('navbar-active') || document.getElementById('navbar-active-tmp'))) {
        elem.remove();
    }

    Flux.Browser.setShowPhoneAccess(showPhoneAccess);

    const navBarContainer = document.getElementById(navBarContainerId);
    if (navBarContainer) {
        render(<NavBar navLinks={navigationLinks} />, navBarContainer);
    }

    const navBarTabletContainer = document.getElementById(navBarTabletContainerId);
    if (navBarTabletContainer) {
        render(<NavBarTablet navLinks={navigationLinks} voiceCallLabel={voiceCallLabel} />, navBarTabletContainer, NavBarRunner);
    }

    const phoneAccessContainer = document.getElementById(phoneAccessContainerId);
    if (phoneAccessContainer) {
        render(<PhoneAccess label={voiceCallLabel} />, phoneAccessContainer);
    }

    PjaxWrapper.addUnloadFunc(() => {
        setNavIntoNonSticky(); // navbar react-element has to be inside navBarContainer, move back to non-sticky to enforce this

        if (navBarContainer) {
            unmountComponentAtNode(navBarContainer);
        }
        if (navBarTabletContainer) {
            unmountComponentAtNode(navBarTabletContainer);
        }
        if (phoneAccessContainer) {
            unmountComponentAtNode(phoneAccessContainer);
        }
    });

    if (scrollToView) {
        toggleStickyNav();
    }
}

export {run};
